import { DxFormControlDefinition } from './interfaces';
import { CONTROL_METADATA_KEY } from './metadata-keys';
import {
  getMetadata,
  hasMetadata
} from '@digitaix/helpers';

export function checkIfControlIsAlreadyPresentByName(
  metadataKey: string,
  target: any,
  controlName: string
): boolean {
  if (hasMetadata(metadataKey, target)) {
    const metadata = getMetadata<Array<DxFormControlDefinition<any>>>(
      metadataKey,
      target
    );
    return metadata.some(md => md.name === controlName);
  }
  return false;
}

export function checkIfControlIsAlreadyPresentByPropertyKey(
  target: any,
  propertyKey: string
): boolean {
  if (hasMetadata(CONTROL_METADATA_KEY, target)) {
    const metadata = getMetadata<Array<DxFormControlDefinition<any>>>(
      CONTROL_METADATA_KEY,
      target
    );
    return metadata.some(md => md.propertyKey === propertyKey);
  }
  return false;
}

export function getControlDefinitionByPropertyKey(
  target: any,
  propertyKey: string
): DxFormControlDefinition<any> | null {
  if (hasMetadata(CONTROL_METADATA_KEY, target)) {
    const metadata = getMetadata<Array<DxFormControlDefinition<any>>>(
      CONTROL_METADATA_KEY,
      target
    );
    return metadata.find(md => md.propertyKey === propertyKey) || null;
  }
  return null;
}
